import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Repeatability_table() {
  const data = [
    {
      parameter: "IM",
      certifiedValue: "3.25",
      method: "IS 1350 Part-I",
      observations: ["3.25", "3.30", "3.28", "3.27", "3.31"],
      avg: "26.50",
      sd: "0.07",
      rsd: "0.26%",
    },
    {
      parameter: "VM",
      certifiedValue: "3.25",
      method: "IS 1350 Part-I",
      observations: ["3.25", "3.30", "3.28", "3.27", "3.31"],
      avg: "26.50",
      sd: "0.07",
      rsd: "0.26%",
    },
    {
      parameter: "ASH",
      certifiedValue: "3.25",
      method: "IS 1350 Part-II",
      observations: ["3.25", "3.30", "3.28", "3.27", "3.31"],
      avg: "26.50",
      sd: "0.07",
      rsd: "0.26%",
    },
    {
      parameter: "GCV",
      certifiedValue: "3.25",
      method: "IS 1350 Part-II",
      observations: ["3.25", "3.30", "3.28", "3.27", "3.31"],
      avg: "26.50",
      sd: "0.07",
      rsd: "0.26%",
    },
  ];

     const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th rowSpan="2">Test Parameter</th>
                  <th rowSpan="2">Certified Value</th>
                  <th rowSpan="2">Test Method</th>
                  <th colSpan="5" className="text-center">
                    Observations
                  </th>
                  <th rowSpan="2">Avg.</th>
                  <th rowSpan="2">SD</th>
                  <th rowSpan="2">RSD%</th>
                </tr>

                <tr>
                  <th>OBS 01</th>
                  <th>OBS 02</th>
                  <th>OBS 03</th>
                  <th>OBS 04</th>
                  <th>OBS 05</th>
                </tr>
              </thead>

              <tbody>
                {data.map((row, index) => (
                  <tr key={index}>
                    <td>{row.parameter}</td>
                    <td>{row.certifiedValue}</td>
                    <td>{row.method}</td>

                    {row.observations.map((obs, i) => (
                      <td key={i}>{obs}</td>
                    ))}

                    <td>{row.avg}</td>
                    <td>{row.sd}</td>
                    <td>{row.rsd}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>


      </section>

      <div className="note_text_holder">
        <p>* Results Are In Air Dried Basis.</p>
      </div>

       <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
}

export default Repeatability_table;
